
import { toast } from 'react-hot-toast'

export function toastWithUndo(message: string, onUndo: () => void) {
  toast.custom(
    (t) => (
      <div
        className={`${
          t.visible ? 'animate-in fade-in slide-in-from-bottom-2' : 'animate-out fade-out slide-out-to-bottom-2'
        } bg-popover border border-border rounded-lg shadow-lg px-4 py-3 flex items-center gap-3 text-sm text-popover-foreground`}
      >
        <span className="flex-1">{message}</span>
        <button
          onClick={() => {
            onUndo()
            toast.dismiss(t.id)
          }}
          className="text-primary font-medium hover:underline shrink-0"
        >
          Undo
        </button>
      </div>
    ),
    { duration: 5000, position: 'bottom-right' },
  )
}
